export const ADD_USERINSTRUCTION_TYPE = 'ADD_USERINSTRUCTION_TYPE';
export const CLEAR_USERINSTRUCTION_TYPE = 'CLEAR_USERINSTRUCTION_TYPE';
export const USER_DETAILS_DATA = 'USER_DETAILS_DATA';
export const GET_ALL_DETAILS_TABS = 'GET_ALL_DETAILS_TABS';
export const CLEAR_USERINSTRUCTION_TAB_TYPE = 'CLEAR_USERINSTRUCTION_TAB_TYPE';
export const GET_USER_INSTRUCTION_CARE_GROUP = 'GET_USER_INSTRUCTION_CARE_GROUP';
export const GET_GROUP_USER_INSTRUCTION_DETAILS = 'GET_GROUP_USER_INSTRUCTION_DETAILS';
export const USER_DETAILS_GROUP_DATA = 'USER_DETAILS_GROUP_DATA';
export const CHECK_UNIQUE_PRODUCT_TYPE = 'CHECK_UNIQUE_PRODUCT_TYPE';
export const GET_CARE_LIBRARIES = 'GET_CARE_LIBRARIES';
export const GET_ALL_COLUMNS = 'GET_ALL_COLUMNS';
